// extracted by mini-css-extract-plugin
export var banner = "_qf-0";
export var settingRow = "_qf-2";
export var titleIcon = "_qf-1";